import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Tag } from 'antd';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import headers from './headers';
import '../../layouts/TableLayout/style.css';
import { contractTypeColor } from '../../utils';
import { ResourceLandingLayout } from '../../layouts';
import useConfigsContext from '../../contexts/ConfigsContext';

const ListContracts = () => {
  const { t } = useTranslation();
  const { configs } = useConfigsContext();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const keyword = params.get('k');

  const exportUrl = keyword && `contracts/search/${keyword}`;

  return (
    <ResourceLandingLayout
      headers={headers}
      exportUrl={exportUrl}
      resourceName="contracts"
      extraQuery={`!amendment_number${
        configs ? `&customer=${configs.client}` : ''
      }`}
      linkState={{ amendment: false }}
      columns={[
        {
          title: t('contracts.list.column.number'),
          dataIndex: 'number',
          sorter: true
        },
        {
          title: t('contracts.list.column.type'),
          dataIndex: 'type',
          sorter: true,
          render: (type) => (
            <Tag color={contractTypeColor[type]}>
              {t(`contracts.form.options.type.${type}`).toUpperCase()}
            </Tag>
          )
        },
        {
          title: t('contracts.list.column.dates'),
          key: 'start_date',
          sorter: true,
          render: (record) => (
            <Typography>
              {`${moment(record.start_date).format('LL') || '-'} - ${moment(
                record.end_date
              ).format('LL') || '-'}`}
            </Typography>
          )
        }
      ]}
    />
  );
};

export default ListContracts;
